import { apiClient } from './client';
import type { PersonalTask, Ticket } from '../types';

export interface PersonalTaskInput {
  title?: string;
  description?: string | null;
  dueDate?: string | null;
  linkedTicketId?: string | null;
  status?: 'open' | 'completed';
  sortOrder?: number;
}

/** Your own list — private to you, never visible to anyone else. */
export const personalTasksApi = {
  list: async (status: 'open' | 'completed' | 'all' = 'open') => {
    const res = await apiClient.get('/personal-tasks', { params: { status } });
    return res.data.data as { tasks: PersonalTask[]; openCount: number };
  },

  create: async (data: PersonalTaskInput) => {
    const res = await apiClient.post('/personal-tasks', data);
    return res.data.data.task as PersonalTask;
  },

  update: async (id: string, data: PersonalTaskInput) => {
    const res = await apiClient.put(`/personal-tasks/${id}`, data);
    return res.data.data.task as PersonalTask;
  },

  remove: async (id: string) => {
    await apiClient.delete(`/personal-tasks/${id}`);
  },

  /** Promote a note-to-self into a real ticket; the item links to it. */
  toTicket: async (
    id: string,
    data: { title?: string; description?: string; priority?: string; type?: string; assignedToId?: string | null } = {},
  ) => {
    const res = await apiClient.post(`/personal-tasks/${id}/ticket`, data);
    return res.data.data as { task: PersonalTask; ticket: Ticket };
  },
};
